import React, { useState, useEffect } from 'react';
import '../../css/layout/Checkout/_inputField.less'

const InputField = props => {
    const {
        type = '', className = '', parentClassName = '',
        placeholder = '', label = '',
        min = '', maxLength = '',
        readOnly = false, errors = {},
        context = {}, revalidate,
        handleInputChange, checkForValidation,
        capitalise = false, disabled = false,
        controlled = false, allowPositiveInt = false
    } = props,
        { ref = '' } = context,

        [value, setValue] = useState(''),

        checkPositiveInteger = (val) => {
            const inputValue = val.replace(/[^0-9]/g, '');
            // Update state only if the input is a positive integer
            if (inputValue === '' || (inputValue > 0 && inputValue % 1 === 0)) {
                setValue(inputValue);
                handleInputChange(capitalise ? val.toUpperCase() : val, context);
            }
        },
        handleInput = e => {
            const val = e.target.value;
            if (typeof handleInputChange === 'function') {
                if (allowPositiveInt) {
                    checkPositiveInteger(val)
                }
                else {
                    setValue(val);
                    handleInputChange(capitalise ? val.toUpperCase() : val, context);
                }
            }
            if (typeof revalidate === 'function') {
                revalidate();
            }
        };

    useEffect(() => {
        setValue(props.value);
    }, []);

    useEffect(() => {
        if (allowPositiveInt) {
            if (props.value == '' || props.value == 0) {
                setValue(props.value);
            }
        }
        else {
            setValue(props.value);
        }
    }, [props.value]);

    useEffect(() => {
        if (checkForValidation) {
            if (typeof handleInputChange === 'function') {
                handleInputChange(capitalise ? props.value.toUpperCase() : props.value, context);
            }
        }
    }, []);

    const isError = errors !== null && errors[ref] !== null && errors[ref] && errors[ref].success === false ? true : false;

    return (
        <div className={`floatinglabel__container-box ${parentClassName}`}>
            <div className="floatinglabel__wrapper">
                {controlled ?
                    <input
                        autoComplete="off"
                        type="text"
                        className={`floatinglabel__wrapper--inputbox ${className} ${(isError) ? 'err-border' : ""} ${(disabled) && 'input-disabled'}`}
                        placeholder={placeholder}
                        onChange={handleInput}
                        maxLength={maxLength}
                        readOnly={readOnly}
                        disabled={disabled}
                        value={value}
                        onWheel={e => e.currentTarget.blur()}
                    />
                    :
                    <input
                        autoComplete="off"
                        type={type}
                        className={`floatinglabel__wrapper--inputbox ${className} ${(isError) && 'err-border'} ${(disabled) && 'input-disabled'}`}
                        placeholder={placeholder}
                        defaultValue={capitalise ? value.toUpperCase() : value}
                        min={min}
                        onBlur={handleInput}
                        maxLength={maxLength}
                        readOnly={readOnly}
                        disabled={disabled}
                        onWheel={e => e.currentTarget.blur()}
                    />
                }
                <label className={`floatinglabel__wrapper--label ${(disabled) && 'inputLabelDisabled'}`}>{label}</label>
            </div>
            {isError && <span className="error">{errors[ref].errMsg}</span>}
        </div>
    );
}

export default InputField;
